// Bridges ui.ts's cast handler to GameScene the same way transferEffect.ts/
// momentumEffect.ts do, but Project has no target object at all -- it acts on
// whatever's within range of the *caster's position and facing*, which is the
// whole reason it exists: it's the first operator that lets a player affect the
// environment without opening any particular object's panel.
//
// The event/result shapes themselves moved to rune-lab/src/sim/casts.ts with the
// handler that consumes them (2026-07-30, sim extraction step 4b) and are
// re-exported here unchanged, so every import site still reads them from this
// module.
import { ProjectEffectEvent, ProjectEffectResult } from '../../rune-lab/src/sim/casts';

export type { ProjectEffectEvent, ProjectEffectResult };

type Handler = (event: ProjectEffectEvent) => ProjectEffectResult;

let handler: Handler | null = null;

export function onProjectEffect(fn: Handler): void {
  handler = fn;
}

export function triggerProjectEffect(event: ProjectEffectEvent): ProjectEffectResult {
  return handler ? handler(event) : { applied: false, hitNames: [], meltedNames: [] };
}
